import { render, staticRenderFns } from "./SavedNotice.vue?vue&type=template&id=01738c5f&"
import script from "./SavedNotice.vue?vue&type=script&lang=js&"
export * from "./SavedNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports